var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Error"},[_c('CloseThick',{attrs:{"size":"150px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }